<template>
  <div>
    <mq-layout
      mq="tablet+"
      class="flex flex-wrap px-4"
      :class="{
        'justify-center': vaults.length == 1,
        'justify-start': vaults.length >= 2,
      }"
    >
      <vault-rectangle
        :vault="vault"
        :stats="getCurrentVaultStats(vault.id)"
        v-for="(vault, index) in vaults"
        :key="index"
        :ref="'vault_' + index"
      ></vault-rectangle>
    </mq-layout>

    <mq-layout
      mq="mobile"
      class="flex flex-wrap px-4"
      :class="{
        'justify-center': vaults.length == 1,
        'justify-start': vaults.length >= 2,
      }"
    >
      <vault-box
        :vault="vault"
        :stats="getCurrentVaultStats(vault.id)"
        v-for="(vault, index) in vaults"
        :key="index"
        :ref="'vault_' + index"
      ></vault-box>
    </mq-layout>
  </div>
</template>

<script>
import VaultBox from "./VaultBox";
import VaultRectangle from "./VaultRectangle";

export default {
  components: { VaultBox, VaultRectangle },
  props: ["vaults", "filtered-vaults"],

  data() {
    return {
      vaultStats: [],
    };
  },

  methods: {
    getVaultStats() {
      axios
        .get(
          `/api/vaults/stats`,
          {
            params: {
              events_from_start_at: moment()
                .add(1, "days")
                .format("YYYY-MM-DD HH:mm:ss"),
            },
          },
          {
            cancelToken: axios.CancelToken.source().token,
          }
        )
        .then(({ data }) => {
          this.vaultStats = data;
        });
    },

    getCurrentVaultStats(vaultId) {
      return this.vaultStats.find((vault) => vault.id == vaultId);
    },
  },

  created() {
    this.getVaultStats();
  },

  watch: {
    filteredVaults(val) {
      _.each(this.vaults, (vault, index) => {
        let vault_idx = "vault_" + index;
        if (_.findIndex(this.filteredVaults, ["id", vault.id]) !== -1) {
          if (!_.isNil(this.$refs[vault_idx])) {
            if(this.$refs[vault_idx][0]) {
              this.$refs[vault_idx][0].toggleVisibility("show");
            }
          }
        } else {
          if (!_.isNil(this.$refs[vault_idx])) {
            if(this.$refs[vault_idx][0]) {
              this.$refs[vault_idx][0].toggleVisibility("hide");
            }
          }
        }
      });
    },
  },
};
</script>
